<div class="page">
  <div class="d-flex justify-content-between">
    <h1>{{ title }}</h1>
    <div class="profile-wrap d-flex align-items-center">
      <app-profile-section></app-profile-section>
    </div>
  </div>
  <div class="top-bar" [class.no-pointer]="loading">
    <div class="search-wrap">
      <div class="d-flex align-items-center">
        <div class="search-bar-wrap">
          @if (!hideTerm) {
            <app-field-search-input
              style="width: 250px;"
              [model]="currentSearch.term"
              [placeholder]="placeholder"
              (clear)="currentSearch.term = ''; onSearch();"
              (enter)="onSearch()"
              (modelChange)="currentSearch.term = $event"
            ></app-field-search-input>
          }
          @if (periodSelector) {
            <app-field-search-period
              [allowClear]="true"
              [codeOptions]="periodOptions"
              [code]="currentSearch.periodCode"
              [from]="currentSearch.periodFrom"
              [placeholder]="'samplings_period_placeholder' | translate"
              [until]="currentSearch.periodUntil"
              (codeChange)="currentSearch.periodCode = $event;"
              (fromChange)="currentSearch.periodFrom = $event;"
              (search)="onSearch();"
              (untilChange)="currentSearch.periodUntil = $event;"
            ></app-field-search-period>
          }
          <ng-content select="ng-container.filters"></ng-content>
        </div>
      </div>
    </div>
    @if (addBtnText) {
      <app-button
        classes="primary-default"
        icon="plus-round"
        [disabled]="false"
        [linkHref]="createLink"
        [submitting]="false"
        [text]="addBtnText"
      ></app-button>
    }
  </div>
  <div class="content-wrap">
    <ng-content></ng-content>
  </div>
</div>
